import { defineStore } from 'pinia';
import type { KegelStateModel } from '@/common/models/store.index.models';

export const useKegelStore = defineStore('kegelMain', {
  state: (): KegelStateModel => {
    return {
      userUuid: '',
      userEmail: '',
      sha256UserEmail: '',
      errorNotificationMessage: '',
      isDisabledBaseDialog: false,
      chargebeeWasCreated: false,
      analyticsAttributions: null,
      clickId: '',
      currentExperimentKey: '',
      currentExperimentVariation: '',
      clickTime: '',
      userData: {},
    };
  },
});
